export default __webpack_public_path__ + "static/media/virtual_img_bg.380181c4.jpg";